/**
 * Public runtime switches for whole features.
 */

/**
 * Encomendas Online: the `/encomendas-online` route, its toolbar button and
 * badge, and the app-wide poll for store notifications and orders to ship.
 * Off by default. Set `VITE_ONLINE_ORDERS_ENABLED=true` to expose the route,
 * toolbar button and badge, and start the app-wide poll. The store gate in
 * `OnlineOrdersService` still decides which stores get it.
 */
const onlineOrdersEnabledValue =
  (typeof window === "undefined"
    ? undefined
    : window.__ZU_PUBLIC_ENV__?.VITE_ONLINE_ORDERS_ENABLED) ||
  import.meta.env.VITE_ONLINE_ORDERS_ENABLED;

export const ONLINE_ORDERS_ENABLED = onlineOrdersEnabledValue === "true";
